var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 8,
    viewBox: "0 0 54 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M26.33 4c0 2.202-1.92 4-4.27 4-2.35 0-4.27-1.798-4.27-4s1.92-4 4.27-4c2.35 0 4.27 1.798 4.27 4zm-4.27 3.05c1.79 0 3.256-1.373 3.256-3.05 0-1.677-1.466-3.05-3.256-3.05-1.79 0-3.256 1.373-3.256 3.05 0 1.677 1.466 3.05 3.256 3.05z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M4.27 7.05C2.48 7.05 1.014 5.678 1.014 4 1.014 2.323 2.48.95 4.27.95c.906 0 1.704.343 2.307.888l.712-.666A4.383 4.383 0 0 0 4.27 0C1.92 0 0 1.798 0 4s1.92 4 4.27 4a4.383 4.383 0 0 0 3.02-1.172l-.713-.666a3.414 3.414 0 0 1-2.307.889z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M35.22 7.05c-1.79 0-3.256-1.373-3.256-3.05 0-1.677 1.466-3.05 3.256-3.05.906 0 1.704.343 2.307.888l.712-.666A4.383 4.383 0 0 0 35.22 0c-2.35 0-4.27 1.798-4.27 4s1.92 4 4.27 4a4.383 4.383 0 0 0 3.02-1.172l-.713-.666a3.374 3.374 0 0 1-2.307.889z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M10.154.22H9.14v7.576h1.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M29.154 2.59H28.14v5.212h1.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M16.134.22H15.12v7.576h1.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M15.634 3.52H9.66v.95h5.974z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M45.462 6.83H40.61v.95h4.852z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M45.462.22H40.61v.95h4.852z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M28.635 1.816L26.91.22h3.45z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M42.093 4.16c0 .424-.302.687-.711.687-.41 0-.712-.243-.712-.687v-.97h.28v.99c0 .283.194.424.432.424.237 0 .431-.141.431-.424v-.99h.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M42.96 4.826h.28V3.21h-.28zm.669-.869l.711-.747h-.345l-.733.747.798.87h.345z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M46.19 4.826l-.496-.626h-.324v.626h-.28V3.21h.625c.345 0 .583.202.583.505a.49.49 0 0 1-.324.465l.518.666h-.302zm-.798-.869h.345c.194 0 .302-.1.302-.262s-.108-.263-.302-.263h-.345z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M48.238 4.544h-.777l-.13.262h-.301l.755-1.636h.086l.755 1.636h-.302zm-.389-.89l-.28.668h.582z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M49.66 4.826h-.28V3.21h.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M51.953 3.21v1.637h-.086L50.81 3.715v1.091h-.28V3.17h.086l1.057 1.111v-1.09h.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b8c9f",
    d: "M53.983 3.432h-.863v.424h.647v.223h-.647v.505h.885v.242H52.84V3.21h1.143z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderLogo1);
export default __webpack_public_path__ + "static/media/slider_logo1.2e70c47387aa71254f6e98820da6d30f.svg";
export { ForwardRef as ReactComponent };